import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'


const getAllCategoryMapUsingVuex = function () {
  let VUEX_ALL_CATEGORY_MAP = []
  if (sessionStorage.getItem('__VUEX_ALL_CATEGORY_MAP__') != null && sessionStorage.getItem('__VUEX_ALL_CATEGORY_MAP__') !== 'null') {
    VUEX_ALL_CATEGORY_MAP = JSON.parse(sessionStorage.getItem('__VUEX_ALL_CATEGORY_MAP__'))
    //
  } else {
    let allCateUrl = `${sessionStorage.gewApiDomain}/v1/ebmp/gew/category/list.json`
    let allCateParam = {
      loginUserToken: sessionStorage.lutk,
    }
    //
    ApiUtil.post(allCateUrl, allCateParam).then(response => {
      VUEX_ALL_CATEGORY_MAP = response.data.resultData
      sessionStorage.setItem('__VUEX_ALL_CATEGORY_MAP__', JSON.stringify(VUEX_ALL_CATEGORY_MAP))
    })
  }
  return VUEX_ALL_CATEGORY_MAP

}
const getGewSCodeMapUsingVuex = function () {
  let VUEX_ALL_SOL_CODE_MAP = {}
//
  if (sessionStorage.getItem('__VUEX_ALL_SOL_CODE_MAP__') != null) {
    VUEX_ALL_SOL_CODE_MAP = JSON.parse(sessionStorage.getItem('__VUEX_ALL_SOL_CODE_MAP__'))
    //
  } else {
    let allSolCodeUrl = `https://single.etnersplatform.com/v1/ebmp/code/allSolutionCodesBySolCd.json`
    let allSolCodeParam = {
      'solCd': ['1007'],
    }
    //
    ApiUtil.post(allSolCodeUrl, allSolCodeParam).then(response => {
      VUEX_ALL_SOL_CODE_MAP = response.data.allSolutionCodeMap
      sessionStorage.setItem('__VUEX_ALL_SOL_CODE_MAP__', JSON.stringify(VUEX_ALL_SOL_CODE_MAP))
    })
  }
  return VUEX_ALL_SOL_CODE_MAP['1007']
}
export default {
  getAllCategoryMapUsingVuex,
  getGewSCodeMapUsingVuex
}
